import React from 'react';
import {Icon as MdiIcon} from '@mdi/react';
import {mdiPaths} from './mdiPaths';

const mdiIconMap: Record<string, string> = {
    'mdi-settings': mdiPaths.mdiCog,
    'mdi-cog': mdiPaths.mdiCog,
    'mdi-content-copy': mdiPaths.mdiContentCopy,
    'mdi-delete-outline': mdiPaths.mdiDeleteOutline,
    'mdi-loading': mdiPaths.mdiLoading,
    'mdi-chevron-down': mdiPaths.mdiChevronDown,
    'mdi-chevron-up': mdiPaths.mdiChevronUp,
    'mdi-chevron-left': mdiPaths.mdiChevronLeft,
    'mdi-chevron-right': mdiPaths.mdiChevronRight,
    'mdi-open-in-new': mdiPaths.mdiOpenInNew,
    'mdi-eye': mdiPaths.mdiEye,
    'mdi-plus': mdiPaths.mdiPlus,
    'mdi-refresh': mdiPaths.mdiRefresh,
    'mdi-account-multiple': mdiPaths.mdiAccountMultiple,
    'mdi-account-box': mdiPaths.mdiAccountBox,
    'mdi-account-switch': mdiPaths.mdiAccountSwitch,
    'mdi-dots-horizontal': mdiPaths.mdiDotsHorizontal,
    'mdi-dots-vertical': mdiPaths.mdiDotsVertical,
    'mdi-dots-horizontal-circle-outline': mdiPaths.mdiDotsHorizontalCircleOutline,
    'mdi-information-variant': mdiPaths.mdiInformationVariant,
    'mdi-information-outline': mdiPaths.mdiInformationOutline,
    'mdi-lock': mdiPaths.mdiLock,
    'mdi-lock-reset': mdiPaths.mdiLockReset,
    'mdi-export': mdiPaths.mdiExport,
    'mdi-share-outline': mdiPaths.mdiShareOutline,
    'mdi-circle-small': mdiPaths.mdiCircleSmall,
    'mdi-help-circle': mdiPaths.mdiHelpCircle,
    'mdi-information': mdiPaths.mdiInformation,
    'mdi-alert': mdiPaths.mdiAlert,
    'mdi-alert-circle': mdiPaths.mdiAlertCircle,
    'mdi-check': mdiPaths.mdiCheck,
    'mdi-close': mdiPaths.mdiClose,
    'mdi-cancel': mdiPaths.mdiCancel,
    'mdi-brain': mdiPaths.mdiBrain,
    'mdi-sort': mdiPaths.mdiSort,
    'mdi-circle': mdiPaths.mdiCircle,
    'mdi-comment-outline': mdiPaths.mdiCommentOutline,
    'mdi-email-outline': mdiPaths.mdiEmailOutline,
    'mdi-magnify': mdiPaths.mdiMagnify,
    'mdi-paperclip': mdiPaths.mdiPaperclip,
    'mdi-toggle-switch': mdiPaths.mdiToggleSwitch,
    'mdi-power': mdiPaths.mdiPower,
    'mdi-compass': mdiPaths.mdiCompass,
    'mdi-gauge': mdiPaths.mdiGauge,
    'mdi-checkbox-marked-outline': mdiPaths.mdiCheckboxMarkedOutline,
    'mdi-tune-vertical': mdiPaths.mdiTuneVertical,
    'mdi-email-newsletter': mdiPaths.mdiEmailNewsletter,
    'mdi-account-group': mdiPaths.mdiAccountGroup,
    'mdi-account-tie': mdiPaths.mdiAccountTie,
    'mdi-chart-line': mdiPaths.mdiChartLine,
    'mdi-chart-box': mdiPaths.mdiChartBox,
    'mdi-chat': mdiPaths.mdiChat,
    'mdi-check-circle': mdiPaths.mdiCheckCircle,
    'mdi-email-off': mdiPaths.mdiEmailOff,
    'mdi-account-plus': mdiPaths.mdiAccountPlus,
    'mdi-timeline-outline': mdiPaths.mdiTimelineOutline,
    'mdi-account-outline': mdiPaths.mdiAccountOutline,
    'mdi-api': mdiPaths.mdiApi,
    'mdi-account-plus-outline': mdiPaths.mdiAccountPlusOutline,
    'mdi-minus-box-multiple': mdiPaths.mdiMinusBoxMultiple,
    'mdi-pencil-outline': mdiPaths.mdiPencilOutline,
    'mdi-phone': mdiPaths.mdiPhone,
    'mdi-comment-quote-outline': mdiPaths.mdiCommentQuoteOutline,
    'mdi-arrow-left-right': mdiPaths.mdiArrowLeftRight,
    'mdi-arrow-down': mdiPaths.mdiArrowDown,
    'mdi-arrow-top-right': mdiPaths.mdiArrowTopRight,
    'mdi-arrow-expand-all': mdiPaths.mdiArrowExpandAll,
    'mdi-subdirectory-arrow-right': mdiPaths.mdiSubdirectoryArrowRight,
    'mdi-delete': mdiPaths.mdiDelete,
    'mdi-menu': mdiPaths.mdiMenu,
    'mdi-calendar': mdiPaths.mdiCalendar,
    'mdi-account': mdiPaths.mdiAccount,
    'mdi-eye-outline': mdiPaths.mdiEyeOutline,
    'mdi-pencil': mdiPaths.mdiPencil,
    'mdi-chart-bar': mdiPaths.mdiChartBar,
    'mdi-chart-areaspline': mdiPaths.mdiChartAreaspline,
    'mdi-chart-pie': mdiPaths.mdiChartPie,
    'mdi-chart-donut': mdiPaths.mdiChartDonut,
    'mdi-view-grid': mdiPaths.mdiViewGrid,
    'mdi-table': mdiPaths.mdiTable,
    'mdi-table-pivot': mdiPaths.mdiTablePivot,
    'mdi-cloud-outline': mdiPaths.mdiCloudOutline,
    'mdi-format-text': mdiPaths.mdiFormatText,
    'mdi-text-box-outline': mdiPaths.mdiTextBoxOutline,
    'mdi-trending-up': mdiPaths.mdiTrendingUp,
    'mdi-numeric': mdiPaths.mdiNumeric,
    'mdi-unfold-less-horizontal': mdiPaths.mdiUnfoldLessHorizontal,
    'mdi-unfold-more-horizontal': mdiPaths.mdiUnfoldMoreHorizontal,
    'mdi-chevron-double-up': mdiPaths.mdiChevronDoubleUp,
    'mdi-minus': mdiPaths.mdiMinus,
    'mdi-restore': mdiPaths.mdiRestore,
    'mdi-undo': mdiPaths.mdiUndo,
    'mdi-swap-vertical': mdiPaths.mdiSwapVertical,
    'mdi-compare': mdiPaths.mdiCompare,
    'mdi-robot': mdiPaths.mdiRobot,
    'mdi-send': mdiPaths.mdiSend,
    'mdi-pound': mdiPaths.mdiPound,
    'mdi-pound-box-outline': mdiPaths.mdiPoundBoxOutline,
    'mdi-tag-outline': mdiPaths.mdiTagOutline,
};

const iconMap: Record<string, string> = {
    'open-in-new': mdiPaths.mdiOpenInNew,
};

export interface IconProps extends React.HTMLAttributes<HTMLSpanElement> {
    name: string; // Accept any string for dynamic icon names
    size?: 'xs' | 'sm' | 'lg' | '1x' | '2x' | '3x' | '4x' | '5x' | '6x' | '7x' | '8x' | '9x' | '10x' | number | string;
    className?: string;
    style?: any;
    spin?: boolean;
    pulse?: boolean;
    fixedWidth?: boolean;
    onClick?: () => void;
    title?: string;
}

/**
 * Icon component that supports MDI icons with backward compatibility
 * Automatically detects icon type and renders appropriately
 */
// Debug function to check available icons
export const getAvailableIcons = () => {
    return Object.keys(mdiIconMap);
};

export const Icon = React.forwardRef<HTMLSpanElement, IconProps>(({
    name,
    size = '1x',
    className = '',
    style,
    spin = false,
    pulse = false,
    fixedWidth = false,
    onClick,
    title,
    ...rest
}, ref) => {
    const nameStr = String(name);


    // Check if it's an MDI icon (starts with 'mdi-')
    if (nameStr.startsWith('mdi-') && mdiIconMap[nameStr as keyof typeof mdiIconMap]) {
        const mdiIconPath = mdiIconMap[nameStr as keyof typeof mdiIconMap];

        // Convert size to MDI size
        let mdiSize: number | string;
        if (typeof size === 'number') {
            mdiSize = size;
        } else if (typeof size === 'string' && (size.endsWith('px') || size.endsWith('em') || size.endsWith('rem'))) {
            // Handle CSS size strings like "18px"
            mdiSize = size;
        } else {
            const sizeMap: Record<string, number> = {
                'xs': 0.6,
                'sm': 0.875,
                'lg': 1.33,
                '1x': 1,
                '2x': 2,
                '3x': 3,
                '4x': 4,
                '5x': 5,
                '6x': 6,
                '7x': 7,
                '8x': 8,
                '9x': 9,
                '10x': 10,
            };
            mdiSize = sizeMap[size as string] || 1;
        }

        // For CSS size strings (like "1em"), wrap MdiIcon in a container with that size
        // and render the icon at size 1 (24px) to fill the container
        if (typeof mdiSize === 'string') {
            const restProps = {...rest} as React.HTMLAttributes<HTMLSpanElement>;
            const restClassName = (restProps as any).className as string | undefined;
            delete (restProps as any).className;
            return (
                <span
                    ref={ref}
                    onClick={onClick}
                    title={title}
                    className={`d-inline-block ${onClick ? 'cursor-pointer' : ''} ${className || ''} ${restClassName || ''}`}
                    style={{
                        width: mdiSize,
                        height: mdiSize,
                        fontSize: mdiSize,
                        ...style
                    }}
                    {...restProps}
                >
                    <svg
                        viewBox="0 0 24 24"
                        style={{width: '100%', height: '100%', display: 'block'}}
                    >
                        <path d={mdiIconPath} fill="currentColor" />
                    </svg>
                </span>
            );
        }

        const spanProps = {...rest} as React.HTMLAttributes<HTMLSpanElement>;
        const restClassName = (spanProps as any).className as string | undefined;
        const spanStyle = (spanProps as any).style;
        delete (spanProps as any).className;
        delete (spanProps as any).style;
        return (
            <span
                ref={ref}
                onClick={onClick}
                title={title}
                className={`d-inline-flex align-items-center ${onClick ? 'cursor-pointer' : ''} ${restClassName || ''}`}
                style={{lineHeight: 0, verticalAlign: 'middle', ...(spanStyle || {})}}
                {...spanProps}
            >
                <MdiIcon
                    path={mdiIconPath}
                    size={mdiSize}
                    className={className}
                    style={style}
                    spin={spin}
                />
            </span>
        );
    }

    // Check if it's a legacy icon name (backward compatibility)
    const legacyIcon = iconMap[nameStr as keyof typeof iconMap];
    if (legacyIcon && typeof legacyIcon === 'string') {
        // It's an MDI icon path, render as MDI
        let mdiSize: number | string;
        if (typeof size === 'number') {
            mdiSize = size;
        } else if (typeof size === 'string' && (size.endsWith('px') || size.endsWith('em') || size.endsWith('rem'))) {
            mdiSize = size;
        } else {
            const sizeMap: Record<string, number> = {
                'xs': 0.6,
                'sm': 0.875,
                'lg': 1.33,
                '1x': 1,
                '2x': 2,
                '3x': 3,
                '4x': 4,
                '5x': 5,
                '6x': 6,
                '7x': 7,
                '8x': 8,
                '9x': 9,
                '10x': 10,
            };
            mdiSize = sizeMap[size] || 1;
        }

        // For CSS size strings, use SVG with viewBox
        if (typeof mdiSize === 'string') {
            const restProps = {...rest} as React.HTMLAttributes<HTMLSpanElement>;
            const restClassName = (restProps as any).className as string | undefined;
            delete (restProps as any).className;
            return (
                <span
                    ref={ref}
                    onClick={onClick}
                    title={title}
                    className={`d-inline-block ${onClick ? 'cursor-pointer' : ''} ${className || ''} ${restClassName || ''}`}
                    style={{
                        width: mdiSize,
                        height: mdiSize,
                        fontSize: mdiSize,
                        ...style
                    }}
                    {...restProps}
                >
                    <svg
                        viewBox="0 0 24 24"
                        style={{width: '100%', height: '100%', display: 'block'}}
                    >
                        <path d={legacyIcon} fill="currentColor" />
                    </svg>
                </span>
            );
        }

        // For numeric sizes, use MdiIcon
        const spanProps = {...rest} as React.HTMLAttributes<HTMLSpanElement>;
        const restClassName = (spanProps as any).className as string | undefined;
        delete (spanProps as any).className;
        return (
            <span
                ref={ref}
                onClick={onClick}
                title={title}
                className={` d-inline-block ${onClick ? 'cursor-pointer' : ''} ${restClassName || ''}`}
                {...spanProps}
            >
                <MdiIcon
                    path={legacyIcon}
                    size={mdiSize}
                    className={className}
                    style={style}
                    spin={spin}
                />
            </span>
        );
    }

    // Icon not found
    console.warn(`Icon "${name}" not found. Available MDI icons:`, Object.keys(mdiIconMap));
    console.warn('Available legacy icons:', Object.keys(iconMap));
    return null;
});

Icon.displayName = 'Icon';

export default Icon;

// Export icon names for TypeScript autocomplete
export type IconName = keyof typeof iconMap;
